/* hooks/useAuth.js
   – one-liner guards for any page                         */

import { useRouter } from 'next/router'
import { useEffect } from 'react'
import { isLoggedIn } from '../utils/auth'
import { useRouterHook } from '../hooks/useRouterHook'

/*  Protect private pages (dashboard, etc.) */
export const useRequireAuth = (redirectTo = '/hire/signin') => {
  const router = useRouter()
  useEffect(() => {
    if (!isLoggedIn()) router.replace(redirectTo)
  }, [router, redirectTo])
}

/*  Keep logged-in users OUT of /hire/signin */
export const useRedirectIfAuth = (redirectTo = 'advertiserDashboardPage', as = 'dashboard') => {
  const { replaceThePageInAdvertiser } = useRouterHook()
  useEffect(() => {
    if (!isLoggedIn()) return
    
    replaceThePageInAdvertiser({
      pathName: redirectTo,
      as: as
    })
  }, [redirectTo])
}
